import React from 'react';
import PropTypes from 'prop-types';

import OptionRow from './OptionRow';

class FilterFieldMobile extends React.Component {
    render() {
        const {id, name, filterOptions, choiceCallback, filterKey, selected, emptyText, disabled} = this.props;

        return (
            <div className="form-group">
                <React.StrictMode>
                    <label htmlFor={`${id}-form`}>{name}</label>
                    <select id={`${id}-form`} className="form-control select-blank" disabled={disabled} value={selected}
                            onChange={(e) => {
                                choiceCallback(filterKey, parseInt(e.target.value));
                            }}>
                        <option>
                            {emptyText}
                        </option>
                        {filterOptions && filterOptions.map((filterOption) => {
                            return (
                                <OptionRow key={filterOption.id} filterOption={filterOption} filterKey={filterKey}/>
                            )
                        })}
                    </select>
                </React.StrictMode>
            </div>
        );
    }
}

FilterFieldMobile.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    filterOptions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            slug: PropTypes.string.isRequired,
        })
    ),
    choiceCallback: PropTypes.func,
    filterKey: PropTypes.string.isRequired,
    selected: PropTypes.oneOfType([PropTypes.number, PropTypes.object, PropTypes.string]),
    emptyText: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
};

export default FilterFieldMobile;